import React from "react";
import { Add, ArrowBack } from "@mui/icons-material";
import { IconButton, Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

interface Props {
  title: string;
  showIcon?: boolean;
  url?: string;
  showPlus?: boolean;
  urlPlus?: string;
}

export const HeaderTitle = ({
  title,
  showIcon,
  url,
  showPlus,
  urlPlus,
}: Props) => {
  const navigate = useNavigate();

  return (
    <Stack direction="row" spacing={2} alignItems="center">
      {showIcon && url && (
        <IconButton
          color="primary"
          onClick={() => {
            navigate(url);
          }}
        >
          <ArrowBack />
        </IconButton>
      )}
      <Typography
        sx={(theme) => ({
          color: theme.palette.primary.main,
          fontWeight: 500,
          fontSize: "1.5rem",
        })}
      >
        {title}
      </Typography>
      {showPlus && urlPlus && (
        <IconButton
          color="primary"
          onClick={() => {
            navigate(urlPlus);
          }}
        >
          <Add />
        </IconButton>
      )}
    </Stack>
  );
};
